export default function prepareDashboardData(data) {
  let company = {
    a: { total: 0, ratio: 0 },
    b: { total: 0, ratio: 0 },
    c: { total: 0, ratio: 0 },
    d: { total: 0, ratio: 0 },
    e: { total: 0, ratio: 0 },
    f: { total: 0, ratio: 0 },
    g: { total: 0, ratio: 0 },
    sum: { total: 0, ratio: 0 }
  };
  let individual = {
    a: { total: 0, ratio: 0 },
    b: { total: 0, ratio: 0 },
    c: { total: 0, ratio: 0 },
    d: { total: 0, ratio: 0 },
    e: { total: 0, ratio: 0 },
    f: { total: 0, ratio: 0 },
    g: { total: 0, ratio: 0 },
    sum: { total: 0, ratio: 0 }
  };
  let portfolio = {
    a: { total: 0, ratio: 0 },
    b: { total: 0, ratio: 0 },
    c: { total: 0, ratio: 0 },
    d: { total: 0, ratio: 0 },
    e: { total: 0, ratio: 0 },
    f: { total: 0, ratio: 0 },
    g: { total: 0, ratio: 0 },
    sum: { total: 0, ratio: 1 }
  };
  if (!data) return { company, individual, portfolio };
  const {
    individualSeverityGroupBreakdown,
    companySeverityGroupBreakdown,
    individualCategoryDistribution,
    companyCategoryDistribution
  } = data;

  let combined = {};

  if (individualSeverityGroupBreakdown) {
    individual.e.total = individualSeverityGroupBreakdown.reduce(
      (sum, item) => sum + item.maxSeverityGroupCount,
      0
    );
  }

  if (companySeverityGroupBreakdown) {
    company.e.total = companySeverityGroupBreakdown.reduce(
      (sum, item) => sum + item.maxSeverityGroupCount,
      0
    );
  }

  if (companyCategoryDistribution) {
    companyCategoryDistribution.forEach(item => (combined[item.categoryID] = item.count));

    company.a.total = combined['1'] + combined['2'];
    company.b.total = combined['3'] + combined['4'];
    company.c.total = combined['5'] + combined['6'] + combined['7'];
    company.d.total = combined['8'] + combined['9'] + combined['10'];
    company.e.total = company.e.total || combined['101'];
    company.f.total = combined['103'];
    company.g.total = combined['104'];
  }
  if (individualCategoryDistribution) {
    individualCategoryDistribution.forEach(item => (combined[item.categoryID] = item.count));

    individual.a.total = combined['A1'] + combined['A2'] + combined['A3'];
    individual.b.total = combined['B1'] + combined['B2'] + combined['B3'];
    individual.c.total = combined['C1'] + combined['C2'] + combined['C3'];
    individual.d.total = combined['D1'] + combined['D2'] + combined['D3'];
    individual.e.total = individual.e.total || combined['E1'] + combined['E2'] + combined['E3'];
    individual.f.total = combined['X4'];
    individual.g.total = Object.keys(combined)
      .filter(key => key.startsWith('X') && key !== 'X4')
      .reduce((sum, key) => sum + combined[key], 0);
  }
  portfolio.a.total = individual.a.total + company.a.total;
  portfolio.b.total = individual.b.total + company.b.total;
  portfolio.c.total = individual.c.total + company.c.total;
  portfolio.d.total = individual.d.total + company.d.total;
  portfolio.e.total = individual.e.total + company.e.total;
  portfolio.f.total = individual.f.total + company.f.total;
  portfolio.g.total = individual.g.total + company.g.total;

  const cSum = Object.keys(company).reduce((sum, k) => sum + company[k].total, 0);
  const iSum = Object.keys(individual).reduce((sum, k) => sum + individual[k].total, 0);
  const sum = cSum + iSum;
  portfolio.sum.total = sum;

  Object.keys(company).forEach(
    key => (company[key].ratio = cSum === 0 ? 0 : company[key].total / sum)
  );
  Object.keys(individual).forEach(
    key => (individual[key].ratio = iSum === 0 ? 0 : individual[key].total / sum)
  );

  company.sum.total = cSum;
  company.sum.ratio = sum === 0 ? 0 : cSum / sum;
  individual.sum.total = iSum;
  individual.sum.ratio = sum === 0 ? 0 : iSum / sum;

  portfolio.a.ratio = sum === 0 ? 0 : (individual.a.total + company.a.total) / sum;
  portfolio.b.ratio = sum === 0 ? 0 : (individual.b.total + company.b.total) / sum;
  portfolio.c.ratio = sum === 0 ? 0 : (individual.c.total + company.c.total) / sum;
  portfolio.d.ratio = sum === 0 ? 0 : (individual.d.total + company.d.total) / sum;
  portfolio.e.ratio = sum === 0 ? 0 : (individual.e.total + company.e.total) / sum;
  portfolio.f.ratio = sum === 0 ? 0 : (individual.f.total + company.f.total) / sum;
  portfolio.g.ratio = sum === 0 ? 0 : (individual.g.total + company.g.total) / sum;

  return { individual, company, portfolio };
}
